// extracted by mini-css-extract-plugin
module.exports = {"sectionFooter":"sectionFooter_sectionFooter__uA2Cz","left":"sectionFooter_left__M8XwW","right":"sectionFooter_right__xSFZb"};